import { ITag } from '~/client/src/shared/models/Tag'
import User from '~/client/src/shared/models/User'

export enum CompanyDirectoryColumnId {
  Checkbox = 'checkbox',
  Name = 'name',
  Code = 'code',
  WhitelistedDomains = 'whitelistedDomains',
  Roles = 'roles',
  Trades = 'trades',
  CompanyType = 'companyType',
  ResponsibleUsers = 'responsibleUsers',
  Members = 'members',
  Status = 'status',
  Classification = 'classification',
}

export const COMPANY_TYPE_GROUP_KEY = 'companyTypeGroup'

export enum CompanyStatus {
  Active = 'active',
  Deactivated = 'deactivated',
}

export enum CompanyClassification {
  Common = 'common',
  VendorOnly = 'vendorOnly',
}

export enum CompanyStatusAction {
  Activate = 'activate',
  Deactivate = 'deactivate',
}

export interface ICompanyRow {
  readonly id: string
  readonly name: string
  readonly code: string
  readonly avatarUrl: string
  readonly whitelistedDomains: readonly string[]
  readonly roleTags: readonly ITag[]
  readonly tradeTags: readonly ITag[]
  readonly typeTags: readonly ITag[]
  readonly responsibleUsers: readonly User[]
  readonly membersCount: number
  readonly status: CompanyStatus
  readonly classification: CompanyClassification
}
